import { Link } from "react-router-dom";
import { useT } from "../i18n/I18nProvider";

// HejPoland wordmark logo with stylized exclamation + Polish flag accent.
// variant="dark" (default) for light backgrounds, variant="light" for dark backgrounds (e.g. footer).
export default function Logo({ size = "default", variant = "dark", testid = "logo" }) {
  const { lp } = useT();
  const isLarge = size === "large";
  const isLight = variant === "light";

  // Wordmark colours: keep the red exclamation as the brand accent in both variants.
  const wordColor = isLight ? "text-white" : "text-slate-900";
  // On dark backgrounds the white half of the flag needs a soft outline so the circle stays readable.
  const flagBorder = isLight ? "border-white/40" : "border-slate-200";

  return (
    <Link to={lp("/")} className="inline-flex items-center gap-2 group" data-testid={testid}>
      {/* Polish flag mini-circle */}
      <span className={`relative inline-flex flex-col items-stretch overflow-hidden rounded-full border ${flagBorder} transition-transform group-hover:scale-110`}
        style={{ width: isLarge ? 32 : 22, height: isLarge ? 32 : 22 }}>
        <span className="flex-1 bg-white"></span>
        <span className="flex-1 bg-[#DC143C]"></span>
      </span>
      <span className={`font-display font-extrabold tracking-tight leading-none flex items-baseline ${isLarge ? "text-2xl" : "text-lg"}`}>
        <span className={wordColor}>Hej</span>
        <span className="text-[#DC143C]">!</span>
        <span className={wordColor}>Poland</span>
      </span>
    </Link>
  );
}
